module.exports = __webpack_public_path__ + "static/media/jon-1920.7e03973b.png";